import { render, staticRenderFns } from "./UserFelicas.vue?vue&type=template&id=3052f658&scoped=true&"
import script from "./UserFelicas.vue?vue&type=script&lang=js&"
export * from "./UserFelicas.vue?vue&type=script&lang=js&"
import style0 from "./UserFelicas.vue?vue&type=style&index=0&id=3052f658&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3052f658",
  null
  
)

export default component.exports